module.exports = __webpack_public_path__ + "static/img/logo-api.c367e680.svg";